import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import { PermissionEnum, PermissionDenied } from '@ui/src';

import ROUTES from '../../routes';

import cn from './styles.module.css';
import { clearDictionariesState } from './store/slice';

const Dictionaries = () => {
  const { activePermissions } = useAppSelector((state) => state.root);

  const match = useMatch(ROUTES.DICTIONARIES);

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      match &&
      activePermissions?.includes(PermissionEnum.DICTIONARIES_LIST)
    ) {
      navigate(ROUTES.DICTIONARIES_LIST);
    }
  }, [activePermissions, match]);

  useEffect(
    () => () => {
      dispatch(clearDictionariesState());
    },
    [],
  );

  useEffect(() => {
    let title = 'Dictionaries';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (activePermissions?.includes(PermissionEnum.DICTIONARIES_LIST)) {
    content = (
      <div className={cn.dictionaries}>
        <Outlet />
      </div>
    );
  } else {
    content = <PermissionDenied />;
  }

  return content;
};

export default Dictionaries;
